export { default } from "./GlobalSearchCuratedSectionsContainer";
